import React, { Component } from 'react';
import './header.css';

class Header extends Component {
  render() {
    return (
      <div>
      <h6 className="header-left">
        <a className="site-title" href="/">Lukasz Soluch</a>
      </h6>

        <h6 className="link-item last">
          <a href="#contact">Contact</a>
        </h6>
        <h6 className="link-item"> 
          <a href="#projects">Portfolio</a>
        </h6>
        <h6 className="link-item"> 
          <a href="#now">Now</a>
        </h6>
      </div>
    );
  }
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/header/header.js
 **/